export var ECardanoExplorer;
(function (ECardanoExplorer) {
    ECardanoExplorer["cardanoscan"] = "cardanoscan";
    ECardanoExplorer["cexplorer"] = "cexplorer";
})(ECardanoExplorer || (ECardanoExplorer = {}));
export var ECardanoExplorerType;
(function (ECardanoExplorerType) {
    ECardanoExplorerType["policy"] = "tokenPolicy";
    ECardanoExplorerType["transaction"] = "transaction";
})(ECardanoExplorerType || (ECardanoExplorerType = {}));
export var EProfileAppActions;
(function (EProfileAppActions) {
    /* -------------------------------------------------------------------------------------------------
     * App
     * -----------------------------------------------------------------------------------------------*/
    EProfileAppActions["LOGOUT"] = "LOGOUT";
    EProfileAppActions["SET_ERROR_REPORTING"] = "SET_ERROR_REPORTING";
    EProfileAppActions["SET_ACTIVE_LANGUAGE"] = "SET_ACTIVE_LANGUAGE";
    EProfileAppActions["SET_CARDANO_EXPLORER"] = "SET_CARDANO_EXPLORER";
})(EProfileAppActions || (EProfileAppActions = {}));
//# sourceMappingURL=types.js.map